// BSV CHANGES 
import { expenseDistanceReducer } from '@app/screens/module-specific-utilities/pages/expense-distance/redux';

type RootState = {
  expenseDistance: ReturnType<typeof expenseDistanceReducer>;
};

// ✅ Base selector to get the whole slice
export const expenseDistanceStateSelector = (state: RootState) => state.expenseDistance;

// ✅ Direct selectors for convenience
export const getExpenseDistanceLoading = (state: RootState) =>
  expenseDistanceStateSelector(state).loading;

export const getExpenseDistanceData = (state: RootState) =>
  expenseDistanceStateSelector(state).data;
